import { RouteType } from "types/RouteType";
import {
  IntraSyncDesignerRoute,
  IntraSyncDesignerPreviewRoute,
} from "@intrasync/designer";
import estimatingDashboardRoute from "./Dashboard/EstimatingDashboard.Route";

const estimatingRoutesList: RouteType[] = [
  estimatingDashboardRoute,
  IntraSyncDesignerRoute as unknown as RouteType,
  IntraSyncDesignerPreviewRoute as unknown as RouteType,
];

export default estimatingRoutesList;
